"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReadMore = void 0;
exports.hasReadMore = hasReadMore;
var truncate_html_1 = __importDefault(require("truncate-html"));
var config_1 = require("../config");
var get_closest_1 = require("../helper/get-closest");
var ReadMore = /*#__PURE__*/function () {
  function ReadMore() {
    var _this = this;
    _classCallCheck(this, ReadMore);
    this.readMoreTextElement = null;
    this.readMoreTextElements = null;
    this.moreLessElements = null;
    this.windowWidth = window.innerWidth;
    this.showChar = this.windowWidth > config_1.CONFIG.variables.width.medium ? 375 : 275;
    this.readMoreChar = this.showChar;
    this.ellipsestext = '...';
    this.readMoreTextElements = document.querySelectorAll(config_1.CONFIG.readMore.main);
    if (this.readMoreTextElements.length > 0) {
      [].forEach.call(this.readMoreTextElements, function (element) {
        _this.truncateText(element);
      });
    }
    this.moreLessElements = document.querySelectorAll(config_1.CONFIG.readMore.toggle);
    if (this.moreLessElements.length > 0) {
      [].forEach.call(this.moreLessElements, function (element) {
        element.addEventListener('click', _this.toggleMoreLess.bind(_this));
      });
    }
  }
  return _createClass(ReadMore, [{
    key: "truncateText",
    value: function truncateText(element) {
      var content = element.innerHTML;
      this.readMoreChar = element.getAttribute('data-read-more-after-chars') ? parseInt(element.getAttribute('data-read-more-after-chars')) : this.showChar;
      if (content.length > this.readMoreChar) {
        var shortContent = (0, truncate_html_1["default"])(content, this.readMoreChar, {
          reserveLastWord: true
        });
        var fullContent = content;
        var html = "\n            <div class=\"truncate-text\" data-hook=\"truncate-text\">\n                ".concat(shortContent, "<span class=\"moreellipses\"><a href=\"\" class=\"moreless more\" data-hook=\"more-less\">Show more</a></span>\n            </div>\n            <div class=\"truncate-text hidden\" data-hook=\"truncate-text\">\n                ").concat(fullContent, "\n                <a href=\"\" class=\"moreless less\" data-hook=\"more-less\">Show less</a></span>\n            </div>");
        element.innerHTML = html;
      }
    }
  }, {
    key: "toggleMoreLess",
    value: function toggleMoreLess(event) {
      event.preventDefault();
      var Wrapper = (0, get_closest_1.getClosest)(config_1.CONFIG.readMore.main, event.target);
      var TextElements = Wrapper.querySelectorAll(config_1.CONFIG.readMore.truncatedText);
      if (TextElements.length > 0) {
        [].forEach.call(TextElements, function (element) {
          element.classList.toggle('hidden');
        });
      }
    }
  }]);
}();
exports.ReadMore = ReadMore;
function hasReadMore() {
  if (document.querySelector(config_1.CONFIG.readMore.main)) {
    return true;
  }
  return false;
}